import { Component } from 'react';
import Raven from 'raven-js';
import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const addRefreshAlert = id => {
  FloatingAlertStore.addAlert({
    id,
    type: 'danger',
    use: 'inline',
    titleText: I18n.text('indexPage.componentErrorAlert.title'),
    message: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "indexPage.componentErrorAlert.message_jsx",
      options: {
        href: window.location.href
      },
      elements: {
        Link
      }
    })
  });
};
class ErrorBoundary extends Component {
  static getDerivedStateFromError(error) {
    // If error is null, this is unexpected but we should still trigger the error boundary
    if (error === null) {
      const fallbackError = new Error('Unknown error occurred (null was provided to error boundary)');
      Raven.captureException(fallbackError, {
        tags: {
          errorType: 'NullErrorInBoundary'
        }
      });
      return {
        error: fallbackError
      };
    }
    return {
      error
    };
  }
  constructor(props) {
    super(props);
    this.state = {
      error: undefined
    };
  }
  componentDidCatch(error, info = {}) {
    const {
      boundaryName,
      showAlertToUser = true
    } = this.props;
    if (showAlertToUser) {
      addRefreshAlert(boundaryName);
    }
    this.reportErrors(error, info);
  }
  reportErrors(error, info = {}) {
    const boundaryName = this.props.boundaryName;
    Raven.captureException(error, {
      extra: Object.assign({}, info),
      tags: Object.assign({
        errorBoundaryName: boundaryName
      }, this.props.additionalErrorTags)
    });
  }
  render() {
    if (!this.state.error) {
      return this.props.children;
    }
    const {
      ErrorComponent
    } = this.props;
    if (ErrorComponent) {
      return /*#__PURE__*/_jsx(ErrorComponent, {
        error: this.state.error
      });
    }
    return null;
  }
}
export default ErrorBoundary;